


















































































































































import { MDInput } from "@micad/vue-components";
import { defineComponent, reactive } from "@vue/composition-api";
import router from "@/router";
import Loading from "@/components/Loading.vue";
import NotificationsPanel from "@/components/Auth/NotificationsPanel.vue";
import BrandingCard from "@/components/Auth/BrandingCard.vue";
import MobileHeader from "@/components/Auth/MobileHeader.vue";
import { LoginResponse } from "@/data/repos/passwordLogin";
import { setSessionClient } from "@/data/repos/sessionSetClient";
import { redirectBackToTheClient } from "@/modules/utils";
import { getDayEnd } from "@/modules/auth";
import { displayRequestStatus } from "@/notifications";
import { getMfaChannels, MfaChannels, mfaSendCode } from "@/data/repos/mfa";
import {
  QBtn,
  QItem,
  QItemSection,
  QItemLabel,
  QRadio,
  QInput,
  QTooltip,
} from "quasar";
import { setKV } from "@/modules/browserLocalStorage";
import { CLIENT_COOKIE_NAME } from "@/interfaces/common.interfaces";

export default defineComponent({
  components: {
    QBtn,
    QItem,
    QInput,
    QItemSection,
    QItemLabel,
    QRadio,
    Loading,
    MDInput,
    NotificationsPanel,
    BrandingCard,
    MobileHeader,
    QTooltip,
  },
  props: { session: String },
  setup(p) {
    const query = router.currentRoute.query;
    const session = reactive<LoginResponse>({} as LoginResponse);
    if (p.session) Object.assign(session, JSON.parse(p.session));

    async function redirect(resp: LoginResponse) {
      setKV(CLIENT_COOKIE_NAME, resp.clientKey);
      redirectBackToTheClient(
        decodeURIComponent(String(router.currentRoute.query.callbackUrl || "")),
        {
          client_key: resp.clientKey,
          user_id: resp.userId,
          session_id: resp.sessionId,
          expiration: getDayEnd().toISOString(),
          return_uri: (query.returnUrl || "") as string,
          // login_token: response.loginToken,
        }
      );
    }

    async function submit() {
      const resp = await setSessionClient(
        session.clientKey,
        state.mfaCode,
        query.app as string | undefined
      );
      displayRequestStatus(resp, "", "Login failed");
      if (resp.ok) await redirect(session);
    }
    const state = reactive({
      resendMFACode: () => !state.resendCountDown && (state.codeSent = false),
      submit,
      clientKey: session.clientKey,
      serverErrorMessage: "",
      loaded: false,
      notifications: [] as [],
      branding: { text: "" },
      brandingPresent: false,
      mfaCode: "",
      mfaChannel: "",
      mfaChannels: { channels: {} } as MfaChannels,
      codeSent: false,
      resendCountDown: 0,
      sendCode(channel: string, key: string) {
        mfaSendCode(channel, key);
        state.resendCountDown = 30;
        const rcTimer = setInterval(() => {
          if (state.resendCountDown) state.resendCountDown -= 1;
          else clearInterval(rcTimer);
        }, 1000);
        state.codeSent = true;
      },
      async cancelMFA() {
        await router.push({ name: "SwitchClient", query: { ...query } });
      },
    });

    // go back to "/pre-login" if missing mandatory data
    // return state;
    if (session.errorMessage === "MFA")
      getMfaChannels(session.clientKey).then((resp) => {
        state.mfaChannels = resp.payload!;
        if (Object.keys(state.mfaChannels.channels).length === 1)
          Object.keys(state.mfaChannels.channels).forEach(
            (ch) => (state.mfaChannel = ch)
          );
        state.loaded = true;
      });
    else router.push({ name: "login", query: router.currentRoute.query });
    return state;
  },
});
